import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cb_admin_token");
  if (token && config.url?.startsWith("/admin")) config.headers.Authorization = `Bearer ${token}`;
  if (token && config.url?.startsWith("/auth/me")) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

const fmt = new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR" });
const fmtPt = new Intl.NumberFormat("pt-PT", { style: "currency", currency: "EUR" });
export const eur = (v, lang = "en") => (lang === "pt" ? fmtPt : fmt).format(v || 0);

export const sizeRange = (sizes = []) => {
  const avail = sizes.filter((s) => s.stock > 0).map((s) => s.size);
  if (!avail.length) return null;
  return { from: avail[0], to: avail[avail.length - 1], count: avail.length };
};

export const imgW = (url, w) => (url && url.includes("images.unsplash.com") ? url.replace(/w=\d+/, `w=${w}`) : url);
